import createIcon from '../../createIcon';

/**
 * @component @name PersonPin
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM3LjAzIDIgMyA2LjAzIDMgMTFDMyAxNS4xNyA1Ljg0IDE4LjY3IDkuNjkgMTkuNjlMMTIgMjJMMTQuMzEgMTkuNjlDMTguMTYgMTguNjcgMjEgMTUuMTcgMjEgMTFDMjEgNi4wMyAxNi45NyAyIDEyIDJaTTEyIDRDMTMuNjYgNCAxNSA1LjM0IDE1IDdDMTUgOC42NiAxMy42NiAxMCAxMiAxMEMxMC4zNCAxMCA5IDguNjYgOSA3QzkgNS4zNCAxMC4zNCA0IDEyIDRaTTEyIDE4LjNDOS41IDE4LjMgNy4yOSAxNy4wMiA2IDE1LjA4QzYuMDMgMTMuMDkgMTAgMTIgMTIgMTJDMTMuOTkgMTIgMTcuOTcgMTMuMDkgMTggMTUuMDhDMTYuNzEgMTcuMDIgMTQuNSAxOC4zIDEyIDE4LjNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PersonPin = createIcon('PersonPin', [
  [
    'path',
    {
      d: 'M12 2C7.03 2 3 6.03 3 11C3 15.17 5.84 18.67 9.69 19.69L12 22L14.31 19.69C18.16 18.67 21 15.17 21 11C21 6.03 16.97 2 12 2ZM12 4C13.66 4 15 5.34 15 7C15 8.66 13.66 10 12 10C10.34 10 9 8.66 9 7C9 5.34 10.34 4 12 4ZM12 18.3C9.5 18.3 7.29 17.02 6 15.08C6.03 13.09 10 12 12 12C13.99 12 17.97 13.09 18 15.08C16.71 17.02 14.5 18.3 12 18.3Z',
      key: 'd5vg6i',
    },
  ],
]);

export default PersonPin;
